import React from 'react';

export const StatCard = ({ title, value, icon, color = 'blue' }) => {
    // Text colors
    const valueColors = {
        blue: 'text-blue-600',
        green: 'text-green-600',
        red: 'text-red-600',
        gray: 'text-gray-600'
    };
    const bgColors = {
        blue: 'bg-blue-100',
        green: 'bg-green-100',
        red: 'bg-red-100',
        yellow: 'bg-yellow-100',
        gray: 'bg-gray-100'
    };

    return (
        <div className={`px-2 py-3 border rounded-lg shadow-sm ${bgColors[color] || 'bg-white'}`}>
            <div className="flex items-center justify-between">
                <p className="m-0 text-sm font-medium text-gray-600">{title}</p>
                <p className={`m-0 text-xl font-bold ${valueColors[color] || 'text-gray-600'}`}>{value}</p>
            </div>
        </div>
    );
};
